/*
 * Copyright (c) 2023. Legalbird eine Marke der R+S Internet Jewels GmbH
 */


import Login from "../../Login/Login";
import LoginTeaser from "../../LoginTeaser/LoginTeaser";
import loginPageStyles from "./loginPageStyle";
import Grid from "@mui/material/Grid";
import PartnersSection from "../../_Sections/PartnersSection/PartnersSection";
import LoginPageBackgroundWrapper from "../../LoginPageBackground/LoginPageBackgroundWrapper";

const LoginPage = () => {
  return (
    <LoginPageBackgroundWrapper>
      <Grid
        container
        sx={{
          justifyContent: "center",
          alignItems: "center"
        }}>
        <Grid
          size={{
            xs: 12,
            sm: 5
          }}>
          <LoginTeaser />
        </Grid>
        <Grid
          sx={loginPageStyles.loginContainer}
          size={{
            xs: 12,
            sm: 3
          }}>
          <Login />
        </Grid>
        <Grid size={12}>
          <PartnersSection />
        </Grid>
      </Grid>
    </LoginPageBackgroundWrapper>
  );
};

export default LoginPage;
